module.exports = __webpack_public_path__ + "img/foot-left-back.45eb8df3.png";